<div class="row">
  <div class="col-xs-12 col-sm-8 col-md-6 col-lg-4 mx-auto">
    <h3 class="text-center">{{ "Template.RecoverPasswordComponent.subHeader_resetPassword" | translate }}</h3>

    @if (isResetVerification) {
      <p class="text-center">{{ "Template.RecoverPasswordComponent.text_enterEmail" | translate }}</p>
      <form (ngSubmit)="checkEmail()" [formGroup]="recoverPasswordForm" novalidate class="mt-2">
        <div class="form-group">
          <label for="email">{{ "Template.RecoverPasswordComponent.label_emailAddress" | translate }}</label>
          <input type="text" class="form-control" id="email" placeholder="{{ 'Template.RecoverPasswordComponent.placeholder_emailAddress' | translate }}" formControlName="email" autocomplete="email" required>
          @if (!recoverPasswordForm.controls['email'].valid && !recoverPasswordForm.controls['email'].untouched) {
            <small class="text-danger">
              {{ "Template.RecoverPasswordComponent.msg_emailRequired" | translate }}
            </small>
          }
        </div>
        <button type="submit" class="btn btn-secondary d-block w-100" [disabled]="isLoading || !recoverPasswordForm.valid">
          {{ "Template.RecoverPasswordComponent.btn_resetPassword" | translate }}
          @if (isLoading) {
            <fa-icon icon="spinner" animation="spin" class="ml-1"></fa-icon>
          }
        </button>
      </form>
    }

    @if (!isResetVerification) {
      <p class="text-center">{{ "Template.RecoverPasswordComponent.text_resetSuccess" | translate }}</p>
    }
  </div>
</div>
